import {
  createContext, useContext, ReactNode,
  useMemo,
} from 'react';

type ContextType = {
  isAutoSave: boolean,
}

export const AutoSaveContext = createContext<ContextType>({
  isAutoSave: false,
});

export const useIsAutoSave = () => {
  const {
    isAutoSave,
  } = useContext(AutoSaveContext);

  return {
    isAutoSave,
  };
};

export function AutoSave({
  children,
  autoSave,
}: {
  children: ReactNode,
  autoSave: () => void,
}) {
  autoSave();
  const value = useMemo(() => ({ isAutoSave: true }), []);
  return (
    <AutoSaveContext.Provider value={value}>
      {children}
    </AutoSaveContext.Provider>
  );
}
